export class CustomerModel {
    protected id: number;
    protected uuid: string;
    protected booking_id: number;
    protected title: string;
    protected firstname: string;
    protected lastname: string;
    protected email: string;
    protected contact_code: number;
    protected contact_number: string;
    protected dob: string;
    protected country: string;
    protected passport_number: string;
    protected full_name: string;
    protected phone_number: string;

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.uuid = obj.uuid ? obj.uuid : '';
        this.booking_id = obj.booking_id ? obj.booking_id : 0;
        this.title = obj.title ? obj.title : '';
        this.firstname = obj.firstname ? obj.firstname : '';
        this.lastname = obj.lastname ? obj.lastname : '';
        this.email = obj.email ? obj.email : '';
        this.contact_code = obj.contact_code ? obj.contact_code : 0;
        this.contact_number = obj.contact_number ? obj.contact_number : '';
        this.dob = obj.dob ? obj.dob : '';
        this.country = obj.country ? obj.country : '';
        this.passport_number = obj.passport_number ? obj.passport_number : '';
        this.full_name = obj.full_name ? obj.full_name : '';
        this.phone_number = obj.phone_number ? obj.phone_number : '';
    }
}
